import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronGroup2FilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M2.5 2c0 .657.003 1.076.054 1.46A6.13 6.13 0 0 0 5.646 8a6.13 6.13 0 0 0-3.09 4.54c-.052.384-.055.803-.055 1.46h1.6c0-.681.005-.982.04-1.247a4.53 4.53 0 0 1 2.68-3.551c.238-.105.52-.19 1.147-.37V7.168c-.627-.18-.909-.265-1.148-.37A4.53 4.53 0 0 1 4.14 3.247C4.105 2.982 4.1 2.68 4.1 2z"
                fill="currentColor"
            />
            <path
                d="M9.633 14c0-.681.005-.982.04-1.247a4.53 4.53 0 0 1 2.68-3.551c.239-.105.52-.19 1.147-.37V7.168c-.626-.18-.908-.265-1.148-.37a4.53 4.53 0 0 1-2.678-3.551c-.036-.265-.04-.566-.04-1.247h-1.6c0 .657.002 1.076.054 1.46A6.13 6.13 0 0 0 11.178 8a6.13 6.13 0 0 0-3.09 4.54c-.052.384-.055.803-.055 1.46z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronGroup2FilledSize16Glyph.displayName = 'ChevronGroup2FilledSize16Glyph';
